import { QuestionType } from '../../pages/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserType } from 'src/pages/types';
import { createUserProfile, loadUserThunk, updateUserAppLang } from './thunk';
import { addSpecialistToFavourite, removeSpecialistFromFavourite } from '../favouriteSpecialits/thunk';

export const userSlice = createSlice({
  name: 'user',
  initialState: null as UserType | null,
  reducers: {
    setUser: (state, action: PayloadAction<UserType | null>) => action.payload,
    setSurveyToUser: (state, action: PayloadAction<QuestionType[]>) => {
      if (state) {
        state.surveyAnswers = action.payload;
      }
    },
    updateUserSpecialistOrder: (state, action) => {
      if (state?.specialist_order) state.specialist_order = action.payload;
    },
    updateAvatars: (state, action: PayloadAction<string>) => {
      if (state?.avatar !== undefined) {
        state.avatar = action.payload;
      }
    },
    updateAppReviewedField: (state, action: PayloadAction<number>) => {
      if (state?.app_reviewed_after_consultation_count !== undefined) {
        state.app_reviewed_after_consultation_count = action.payload;
      }
    },
    updateUserPsychologist: (state, action: PayloadAction<string>) => {
      if (state?.email) {
        state.user_psychologists = action.payload as string;
      }
    },
    setUsersCountry: (state, action: PayloadAction<boolean>) => {
      if (state) {
        state.financial_support_approved = action.payload;
      }
    },
    addUserFavourite: (state, action: PayloadAction<string>) => {
      if (state?.favourite_specialist_ids) {
        state?.favourite_specialist_ids.push(action.payload);
      } else {
        state!.favourite_specialist_ids = [action.payload];
      }
    },
    deleteUserFavorite: (state, action: PayloadAction<string>) => {
      const indexOfFavourite =
        state?.favourite_specialist_ids && state.favourite_specialist_ids.indexOf(action.payload);

      if (typeof indexOfFavourite === 'number' && indexOfFavourite !== -1) {
        state?.favourite_specialist_ids?.splice(indexOfFavourite, 1);
      }
    },
    logout: (state) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUserThunk.fulfilled, (state, action) => action.payload)
      .addCase(addSpecialistToFavourite.pending, (state, action) => {
        const specialistId = action.meta.arg;
        const isSpecialistInFavourite = state?.favourite_specialist_ids?.find((id) => id === action.meta.arg.id);

        if (specialistId && !isSpecialistInFavourite && state) {
          state.favourite_specialist_ids = state?.favourite_specialist_ids
            ? [...state.favourite_specialist_ids, specialistId.id]
            : [specialistId.id];
        }
      })
      .addCase(removeSpecialistFromFavourite.pending, (state, action) => {
        if (state?.favourite_specialist_ids) {
          const indexOfFavourite = state.favourite_specialist_ids.indexOf(action.meta.arg.id ?? '');

          if (typeof indexOfFavourite === 'number' && indexOfFavourite !== -1) {
            state.favourite_specialist_ids.splice(indexOfFavourite, 1);
          }
        }
      })
      .addCase(updateUserAppLang.fulfilled, (state, action) => {
        if (state) {
          state.app_lang = action.payload;
        }
      })
      .addCase(createUserProfile.fulfilled, (state, action) => {
        return action.payload;
      });
  },
});

export const {
  setUser,
  updateAvatars,
  setSurveyToUser,
  updateUserPsychologist,
  setUsersCountry,
  addUserFavourite,
  deleteUserFavorite,
  updateAppReviewedField,
  logout,
  updateUserSpecialistOrder,
} = userSlice.actions;
export default userSlice.reducer;
